<template>
  <div id="app" class="" @click="calculate_v($event)">
    <div class="container mx-auto p-2" style="height: 125px">
      <BannerComponent
        background_image_url="header_big_2"
        text_1="Informatiemanagement"
        text_1_classes="text-white"
        text_2="bij multidisciplinaire"
        text_2_classes="text-white"
        text_3="zorgprojecten"
        text_3_classes="text-white"
      />
    </div>

    <div class="container-xl mx-lg w-full">
      <div class="flex" style="position: relative; overflow: hidden">
        <img
          alt="inviting hand"
          style="
            width: 100%;
            z-index: 1;
            object-fit: cover;
          "
          src="@/assets/img/Header_licht.png"
        />
        <div
          class="flex-1 text-grey-lighter py-8 m-2 mr-8"
          style="
            z-index: 2;
            position: absolute;
            top: 0px;
            right: 0px;
            padding-top: 10px;
          "
        ></div>
      </div>
    </div>

    <div class="stickys h-24 md:h-12 -mt-1 top-4 bg-white w-full">
      <div class="text-center w-full mb-4">
        <div
          class="mx-auto w-full bg-white pt-2 flex flex-row md:flex-row justify-center flex-wrap "
        >
          <a
            href=""
            @click.prevent="scrollTo('intro')"
            class="w-1/4 md:w-1/8 justify-self-center text-gray-800 bg-gray-500 flex text-sm md:text-lg text-black whitespace-pre ml-2 p-2 hover:bg-grey-lighter border-b border-grey-dark"
            ><span>Over D3</span></a
          >
          <a
            href=""
            @click.prevent="scrollTo('in_beeld')"
            class="w-1/4 md:w-1/8 justify-self-center text-gray-800 bg-gray-500 flex text-sm md:text-lg text-black whitespace-pre ml-2 p-2 hover:bg-grey-lighter border-b border-grey-dark"
            ><span>D3 in beeld</span></a
          >
          <a
            href=""
            @click.prevent="scrollTo('roswijkscan')"
            class="w-1/4 md:w-1/8 justify-self-center text-gray-800 bg-gray-500 flex text-sm md:text-lg text-black whitespace-pre ml-2 p-2 hover:bg-grey-lighter border-b border-grey-dark"
            ><span>ROS wijkscan</span></a
          >
          <a
            href=""
            @click.prevent="scrollTo('imdashboard')"
            class="w-1/4 md:w-1/8 justify-self-center text-gray-800 bg-gray-500 flex text-sm md:text-lg text-black whitespace-pre ml-2 p-2 hover:bg-grey-lighter border-b border-grey-dark"
            ><span>IM-dashboard</span></a
          >
          <a
            href=""
            @click.prevent="scrollTo('contact')"
            class="w-1/4 md:w-1/8 justify-self-center text-gray-800 bg-gray-500 flex text-sm md:text-lg text-black whitespace-pre ml-2 p-2 hover:bg-grey-lighter border-b border-grey-dark"
            ><span>Contact</span></a
          >
        </div>
      </div>
    </div>

    <div class="container mx-auto p-2 -mt-4">
      <SpacerComponent
        :height="'20px'"
        :classes="basic_spacer_classes"
        background_image_url=""
      />

      <SpacerComponent
        :height="basic_spacer_height + 'px'"
        :classes="basic_spacer_classes"
        background_image_url=""
      />

      <div class="lg:flex lg:flex-row">
        <div class="w-full lg:w-1/2">
          <div class="select-text pr-8" id="intro">
            <p class="header_1">
              Over D3
            </p>

            <p class="paragraph">
              Data, dialoog, doen: dat is onze methode. Om zo te helpen bij het
              professioneel toepassen van informatiemanagement in zorgprojecten
              en programma’s. Dat doen we bijvoorbeeld door het ontwikkelen van
              tools waarmee ROS-adviseurs informatiemanagement kunnen toepassen
              in hun projecten.
            </p>
            <p class="paragraph">
              Data, dialoog, doen: informatie verzamelen, het gesprek aangaan én
              handelen. Een aanpak die altijd zorgt voor extra dimensie.
              Bovendien werken we ook binnen diverse domeinen van de zorgsector
              waarbij een wijkgerichte en populatiegerichte aanpak centraal
              staat en we onszelf altijd afvragen: waarmee is de inwoner
              geholpen?
            </p>
            <p class="paragraph">
              Wie zijn we? D3 is een kenniscentrum met expertise en ondersteunt
              informatiemanagement van de organisaties uit het ROS-netwerk. We
              zijn met de kennis die we in huis hebben ook aanjager van
              vernieuwing en innovatie. Dat doen we binnen de eerstelijnszorg
              maar ook over de domeinen heen (sociaal domein, nulde lijn, tweede
              lijn).
            </p>
          </div>
        </div>

        <div class="w-full md:w-1/2 text-white p-2">
          <iframe
            src="https://diasli.de/4047/eKmzhQC7eVf#embed,fill"
            class="-m-t-4"
            scrolling="no"
            width="570"
            height="820"
            frameborder="0"
          ></iframe>
        </div>
      </div>

      <p class="header_1 mt-24 mb-6 md:text-center" id="in_beeld">In beeld</p>
      <div class="lg:flex lg:flex-row justify-center w-full align-center">
        <div class="w-full lg:w-1/3 h-full">
          <template v-if="youtube.data == true">
            <div class="cursor-pointer" @click="set_youtube_current('data')">
              <iframe
                src="https://www.youtube.com/embed/A4pGsANvJdM?rel=0;showinfo=0;controls=1;autohide=1;autoplay=1;color=white"
                frameborder="0"
                allowfullscreen
                height="200px"
                class="w-full"
              ></iframe>
            </div>
          </template>
          <template v-else>
            <div class="">
              <img
                @click="set_youtube_current('data')"
                class="mr-auto ml-auto block center w-40 h-40 hover:shadow-2 cursor-pointer"
                src="@/assets/img/youtube_data.png"
                alt="Youtube data"
              />
            </div>
          </template>
        </div>

        <div class="w-full lg:w-1/3 ">
          <template v-if="youtube.dialoog == true">
            <div
              class="cursor-pointer"
              @click="youtube.dialoog = !youtube.dialoog"
            >
              <iframe
                src="https://www.youtube.com/embed/O5_Mdk1Iy9s?rel=0;showinfo=0;controls=1;autohide=1;autoplay=1;color=white"
                frameborder="0"
                allowfullscreen
                height="200px"
                class="w-full"
              ></iframe>
            </div>
          </template>
          <template v-else>
            <div>
              <img
                @click="set_youtube_current('dialoog')"
                class="mr-auto ml-auto block center w-40 h-40 hover:shadow-2 cursor-pointer"
                src="@/assets/img/youtube_dialoog.png"
                alt="Youtube dialoog"
              />
            </div>
          </template>
        </div>
        <div class="w-full lg:w-1/3">
          <template v-if="youtube.doen == true">
            <div class="cursor-pointer" @click="youtube.doen = !youtube.doen">
              <iframe
                src="https://www.youtube-nocookie.com/embed/-LUHm-QtG6g?rel=0;showinfo=0;controls=1;autohide=1;autoplay=1;color=white"
                frameborder="0"
                height="200px"
                class="w-full"
                allowfullscreen
              ></iframe>
            </div>
          </template>
          <template v-else>
            <div>
              <img
                @click="set_youtube_current('doen')"
                class="mr-auto ml-auto block center w-40 h-40 hover:shadow-2 cursor-pointer"
                src="@/assets/img/youtube_doen.png"
                alt="Youtube doen"
              />
            </div>
          </template>
        </div>
      </div>

      <SpacerComponent
        :height="basic_spacer_height + 'px'"
        :classes="basic_spacer_classes"
      />

      <SpacerComponent
        :height="basic_spacer_height + 'px'"
        :classes="basic_spacer_classes"
      />

      <div class="flex flex-row mt-12 md:w-2/3 mx-auto justify-center ">
        <div class="w-1/3">
          <a href="https://d3wijkscan.nl/" class="hover:shadow-2 inline-flex">
            <img
              alt="ROS Wijkscan"
              href="https://d3wijkscan.nl/"
              :src="require('@/assets/img/ros_wijkscan_dashboard.jpg')"
              class="h-48"
            />
          </a>
        </div>
        <div class="w-2/3  text-left pl-2 " id="roswijkscan">
          <a href="https://d3wijkscan.nl/" class="w-full inline-flex">
            <p class="header_1 text-black" href="https://d3wijkscan.nl/">
              ROS Wijkscan
            </p>
          </a>
          <p class="paragraph  " href="https://d3wijkscan.nl/">
            De ROS Wijkscan is hét startpunt voor een kwantitatieve verkenning
            van een gebied. De Wijkscan verzamelt openbare cijfers over de
            bevolkingssamenstelling, de gezondheidssituatie, de zorgvraag, het
            zorgaanbod, etc. In deze tool vind je datavisualisaties en kan je de
            achterliggende data downloaden om zelf mee aan de slag te gaan.
          </p>
        </div>
      </div>

      <div class="flex flex-row mt-12 md:w-2/3 mx-auto ">
        <div class="w-2/3  text-left " id="imdashboard">
          <a href="https://diadashboard.nl/cbb_informatiemanagement">
            <p class="header_1 text-black">IM-Dashboard</p>
          </a>
          <p class="paragraph  ">
            Het informatiemanagement-dashboard fungeert als database van
            ROS-projecten en als handboek. Alle ROS’en hebben projecten
            ingevoerd en aangegeven hoe ze in die projecten het
            informatiemanagement (IM) hebben vormgegeven. Daarnaast geven we
            handvatten voor het maken van monitoringsplannen, vragenlijsten,
            etc.
          </p>
        </div>
        <div class="w-1/3">
          <a
            href="https://diadashboard.nl/cbb_informatiemanagement"
            class="hover:shadow-2"
          >
            <img
              alt="ROS Wijkscan"
              :src="require('@/assets/img/im_dashboard_person_with_chart.png')"
              class=""
            />
          </a>
        </div>
      </div>
    </div>

    <div class="container mx-auto">
      <SpacerComponent
        :height="basic_spacer_height + 'px'"
        :classes="basic_spacer_classes"
      />

      <FooterComponent id="contact"></FooterComponent>

      <SpacerComponent :height="'200px'" :classes="basic_spacer_classes" />

      <SpacerComponent
        :height="basic_spacer_height + 'px'"
        :classes="basic_spacer_classes"
      />

      <div v-if="v.hidden">
        <h2 class="text-center my-8">Made by Wouter & Titia</h2>

        <SpacerComponent
          :height="'900px'"
          :classes="basic_spacer_classes"
          :background_image_url="require('@/assets/img/deze.jpg')"
        />
      </div>

      <SpacerComponent
        :height="basic_spacer_height + 'px'"
        :classes="basic_spacer_classes"
      />
    </div>
  </div>
</template>

<script>
import BannerComponent from "./components/BannerComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
import SpacerComponent from "./components/SpacerComponent.vue";

export default {
  name: "app",
  components: {
    BannerComponent,
    FooterComponent,
    SpacerComponent,
  },
  data: function() {
    return {
      basic_spacer_height: 75,
      basic_spacer_classes: "",
      youtube: {
        data: false,
        advisuer: false,
        dialoog: false,
        doen: false,
        current: false,
      },
      rows: [
        {
          id: 1,
          title: "Verkenning",
          items: [
            {
              id: 1,
              text: "ROS-Wijkscan",
              url: "https://d3wijkscan.nl/",
              image_url: "ROS_wijkscan.svg",
              long_text:
                "Informatie op maat over onder andere bevolkingssamenstelling, huishoudens, economische status, zorgvraag en zorgaanbod.",
            },
            {
              id: 2,
              text: "Triple Aim dashboard",
              url: "https://diadashboard.nl/cbb-triple-aim/",
              image_url: "Triple_aim.svg",
              long_text:
                "Een overzicht van relevante informatie uit publiek beschikbare bronnen.",
            },
          ],
        },
        {
          id: 2,
          title: "Onderzoeksopzet",
          items: [
            {
              id: 1,
              text: "IM-dashboard",
              long_text:
                "Informatie over voltooide ROS-projecten. Om van te leren en ter inspiratie.",
              url: "https://diadashboard.nl/cbb_informatiemanagement",
              image_url: "IM-dashboard.svg",
            },
            {
              id: 2,
              text: "IM-handboek",
              long_text:
                "Handboek informatiemanagement. Een overzicht van de verzamelde inzichten in informatiemanagement voor de ROS.",
              //url: "http://dialogiconderzoek.nl/tripleaim/Handboek%20IM%20voor%20ros-adviseurs%20versie%2013-12-2018.pdf",
              // url: "https://diadashboard.nl/cbb_informatiemanagement/projectindeling#",
              url:
                "https://diadashboard.nl/login/cbb_informatiemanagement%252FRegioanalyse#",
              image_url: "Handboek.svg",
            },
          ],
        },
        {
          id: 3,
          title: "Andere bronnen",
          items: [
            {
              id: 2,
              text: "Bronnenlijst",
              long_text:
                "Lijst van bronnen die kunnen ondersteunen bij informatiemanagement in projecten.",
              url:
                "https://diadashboard.nl/cbb_informatiemanagement/Regioanalyse#",
              // url: "https://diadashboard.nl/cbb-triple-aim/relevante-documenten",
              image_url: "Andere_bronnen.svg",
            },
            // {
            //   id: 1,
            //   text: "ZOJP",
            //   long_text: "Projectendatabank met verschillende ROS projecten.",
            //   url: "https://www.dejuistezorgopdejuisteplek.nl/",
            //   image_url: "ZOJP.svg",
            // },
          ],
        },
      ],
      v: {
        a: 0,
        hidden: false,
      },
      c: "ctrlKey",
      g: "target.className",
      l: "",
    };
  },
  methods: {
    set_youtube_current(item) {
      this.youtube.data = false;
      this.youtube.dialoog = false;
      this.youtube.doen = false;
      this.youtube[item] = true;
      this.youtube.current = item;
    },

    scrollTo: function(item) {
      var element = document.getElementById(item);
      var offset = 60;

      const y = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: y - offset,
        behavior: "smooth",
      });
    },

    calculate_v: function(e) {
      this.l = e[this.g];
      if (e) {
        // console.log(e.target.className);
        if (e[this.c] == true && this.v.first == true) {
          this.v.a++;
          // console.log(this.v.a);
          if (this.v.a == 0) {
            // console.log("GO");
            this.v.hidden = true;
          } else {
            this.v.hidden = false;
          }
        } else {
          this.v.hidden = false;
          this.v.a--;
          if (e.target.className == "text-center header_1 m-4 mb-6 hello") {
            // console.log("1 true");
            this.v.first = true;
          } else {
            this.v.first = false;
          }
        }
      }
    },
  },
}; //
</script>

<style>
iframe {
  overflow: hidden;
}
div.stickys {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  /* background-color: yellow; */
  /* padding: 50px; */
  /* font-size: 20px; */
}

#app {
  font-family: "IBM Plex Sans", sans-serif;
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 00px;
}
p,
button,
h1,
h2,
h3,
a {
  @apply tracking-normal leading-normal text-lg;

  text-decoration: none;
}

button {
  @apply rounded-lg;
}
h3 {
  @apply tracking-wide leading-normal text-lg;
  text-decoration: none;
}
h1,
h2 {
  @apply tracking-wider;
}
</style>
